import DataGridActionHeader from "components/common/controls/grid/DataGridActionHeader";
import LicenseEditorPopup from "./LicenseEditorPopup";
import { useState } from "react";
import { EditorMode } from "shared/enums/EditorModeEnum";

export default function ManageLicenseGridActionHeader() {
  const [isCreateNewLicensePopupVisible, setIsCreateNewLicensePopupVisible] = useState(false);

  const handleCreateNewLicenseClick = () => {
    setIsCreateNewLicensePopupVisible(true);
  };
  const handleCreateNewLicensePopupClose = () => {
    setIsCreateNewLicensePopupVisible(false);
  };

  return (
    <>
      <DataGridActionHeader
        displayNew={true}
        newButtonText="Add License"
        onNewClick={handleCreateNewLicenseClick}
      />
      {isCreateNewLicensePopupVisible && (
        <LicenseEditorPopup
          onClose={handleCreateNewLicensePopupClose}
          mode={EditorMode.Create}
        />
      )}
    </>
  );
};
